"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePunchTile = void 0;
const react_i18next_1 = require("react-i18next");
const luxon_1 = require("luxon");
const DateManagement_1 = require("../../utils/DateManagement");
function usePunchTile({ time, militaryTime, type, selectedDate, isMissedPunchClickableRowEnabled }) {
    var _a;
    const { t } = (0, react_i18next_1.useTranslation)();
    const missed = !time;
    const timeDT = (_a = time !== null && time !== void 0 ? time : selectedDate) !== null && _a !== void 0 ? _a : luxon_1.DateTime.local();
    const timeString = !missed ? (0, DateManagement_1.getTimeString)(time, militaryTime) : '--:--';
    const month = t(`time_and_attendance_PunchCard_daySelector_${timeDT.month}`);
    const day = timeDT.day;
    const year = timeDT.year;
    let transKey;
    if (missed) {
        transKey = isMissedPunchClickableRowEnabled
            ? 'AddMissedPunch'
            : 'missed_punch';
    }
    else {
        transKey = type;
    }
    const title = t(`time_and_attendance_PunchTile_${transKey}`);
    const ariaLabel = `${title} ${timeString} ${month} ${day}`;
    return {
        missed,
        title,
        year,
        month,
        day,
        timeString,
        ariaLabel,
        timeDT
    };
}
exports.usePunchTile = usePunchTile;
